import { CssBaseline } from "@mui/material";
import {
  StyledEngineProvider,
  ThemeProvider as MUIThemeProvider,
} from "@mui/material/styles";

import { collectionsTheme } from "./collectionsTheme";
import GlobalStyles from "./globalStyles";

// The eshop reuses the Collections design tokens from the fitter dashboard so
// it matches the rest of the MTS product family: MTS red primary, MTS orange
// secondary, neutral text, pale-yellow status pills, soft card shadows on hover.

type Props = {
  children: React.ReactNode;
};

export default function ThemeProvider({ children }: Props) {
  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={collectionsTheme}>
        <CssBaseline />
        <GlobalStyles />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}
